import { jsx as e, Fragment as w, jsxs as p } from "react/jsx-runtime";
import { useStyleConfig as x, Button as O, Box as t, Stack as V } from "@chakra-ui/react";
import { formatDate as W } from "../../node_modules/date-fns/format.js";
import { ThemeColorVariable as r, ThemeSpaceVariable as m } from "../../theme/theme-types.js";
const L = ({
  gridColumn: u,
  gridRow: b,
  gridIndex: C,
  day: c,
  handleDateChange: g,
  variant: o,
  isDisabled: d,
  isStrikeThrough: s,
  hasBlueDot: h,
  hasYellowDot: k,
  hasGreenDot: f,
  hasGreyDot: D,
  hasRedDot: y,
  selectWeek: a,
  isHoliday: i
}) => {
  const S = x("DateCell", { variant: o }), R = x("DateCellWeek", { variant: o }), n = (o === "selectedDay" || o === "startDateRange" || o === "endDateRange") && !a, l = {
    borderRadius: "50%",
    border: n ? "solid 1.5px white" : "",
    width: n ? "7.5px" : "6px",
    height: n ? "7.5px" : "6px"
  }, B = C % 7 === 6;
  return /* @__PURE__ */ e(w, { children: /* @__PURE__ */ p(
    O,
    {
      __css: a ? R : S,
      type: "button",
      sx: a && o === "selectedDay" && B ? {
        borderTopRightRadius: "10px",
        borderBottomRightRadius: "10px"
      } : {},
      variant: o,
      isDisabled: d || s,
      onClick: () => {
        !d && !s && g(c);
      },
      gridColumn: u,
      gridRow: b,
      display: "flex",
      "data-testid": "date-picker-date-cell",
      children: [
        /* @__PURE__ */ e(
          t,
          {
            "data-testid": i ? "holiday" : void 0,
            sx: { color: i ? r.Error : "inherit" },
            children: W(c, "d")
          }
        ),
        s && /* @__PURE__ */ e("span", {}),
        /* @__PURE__ */ p(
          V,
          {
            position: "absolute",
            bottom: m.XSmall,
            direction: "row",
            spacing: m.XSmall,
            children: [
              h && /* @__PURE__ */ e(
                t,
                {
                  sx: {
                    ...l,
                    backgroundColor: r.Info
                  }
                }
              ),
              f && /* @__PURE__ */ e(
                t,
                {
                  sx: {
                    ...l,
                    backgroundColor: r.Success
                  }
                }
              ),
              k && /* @__PURE__ */ e(
                t,
                {
                  sx: {
                    ...l,
                    backgroundColor: r.Warning
                  }
                }
              ),
              D && /* @__PURE__ */ e(
                t,
                {
                  sx: {
                    ...l,
                    backgroundColor: r.Neutral
                  }
                }
              ),
              y && /* @__PURE__ */ e(
                t,
                {
                  sx: {
                    ...l,
                    backgroundColor: r.Error
                  }
                }
              )
            ]
          }
        )
      ]
    }
  ) });
};
export {
  L as DatePickerDateCell
};
